module.exports = __webpack_public_path__ + "static/media/SDFSA_7-240w.4bae5019.jpg";